import { Link } from 'react-router-dom'
import { useTheme } from '../hooks/useTheme'

// styles
import './CardList.css'

export default function JournalList({ journals, selectedCat }) {
    const { mode } = useTheme()



    return (
        <>
        {selectedCat === "category" ?
        <div className='card-list'>
            {journals.map(journal => (
                <div key={journal.id} className={`card ${mode}`}>
                    <h3>{journal.title}</h3>
                    <div className='icon-container'>
                        <img src={journal.icon} alt={`${ journal.title} icon`} className="card-icon"/>
                    </div>
                    {journal.category && <div className='category'>{journal.category}</div>}
                    <div className='date'>{journal.date}</div>
                    <Link to={`/journals/${journal.id}`}>Learn More</Link>
                </div>
            ))}
        </div>:
        <div className='card-list'>
        {journals.map(journal => (
            journal.category === selectedCat && <div key={journal.id} className={`card ${mode}`}>
                <h3>{journal.title}</h3>
                <div className='icon-container'>
                    <img src={journal.icon} alt={`${ journal.title} icon`} className="card-icon"/>
                </div>
                {journal.category && <div className='category'>{journal.category}</div>}
                <div className='date'>{journal.date}</div>
                <Link to={`/journals/${journal.id}`}>Learn More</Link>
            </div>
        ))}
    </div>
        }
        </>
    )
}